import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';

export interface ApprovalItem {
  type: string;
  id: number;
  title: string;
  amount: number | null;
  status: string;
  submitted_at: string;
  community: string;
  requestor: string;
  // Bill-specific fields
  reference?: string;
  bill_date?: string;
  due_date?: string;
  vendor_name?: string;
  vendor_license_expiry?: string;
}

@Injectable({ providedIn: 'root' })
export class ApprovalsService {
  private http = inject(HttpClient);

  getMyApprovals(filters: { association_id?: number; type?: string } = {}): Observable<any> {
    return this.http.get('api/approvals/my', { params: filters as any });
  }
}
